const LogIcon = (props) => (
	<svg 
		xmlns="http://www.w3.org/2000/svg" 
		width="24" height="24" viewBox="0 0 24 24"
		{...props} 
	>
		<path d="M21 9C21 6.23858 18.7614 4 16 4C14.6673 4 13.4564 4.52139 12.5601 5.37131L6 12L12 13L13 19L20.0004 12C20.6281 11.1643 21 10.1256 21 9Z" fill="currentColor"/>
		<circle cx="9" cy="16" r="4" stroke="currentColor" fill="none" strokeWidth="2"/>
	</svg>
)

export default LogIcon